const initState = {
  loading: false,
  eligible: false,
  eligibility: null,
  tournamentId: null,
  err: "",
};

export const TournamentEligibilityReducer = (state = initState, action) => {
  switch (action.type) {
    case "TOURNAMENT_ELIGIBILITY_LOADING":
      return {
        ...state,
        loading: true,
        err: "",
      };

    case "TOURNAMENT_ELIGIBILITY_SUCCESS":
      return {
        ...state,
        loading: false,
        eligible: Boolean(action.eligible),
        eligibility: action.eligibility ?? null,
        tournamentId: action.tournamentId ?? null,
        err: "",
      };

    case "TOURNAMENT_ELIGIBILITY_ERROR":
      return {
        ...state,
        loading: false,
        eligible: false,
        eligibility: null,
        tournamentId: null,
        err: action.error || "",
      };

    case "TOURNAMENT_ELIGIBILITY_CLEAR":
      return { ...initState };

    default:
      return state;
  }
};
